import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChildren } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatTable, MatTableModule } from '@angular/material/table';

export interface PeriodicElement {
  parname: string;
  parvalue: string;
  isEditing: boolean;
}



@Component({
  selector: 'app-add-model-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule, MatDividerModule, MatTableModule, ReactiveFormsModule],
  templateUrl: './add-model-dialog.component.html',
  styleUrl: './add-model-dialog.component.scss',
})
export class AddModelDialogComponent {
  // apiResponse = {
  //   "name": "gpt-4o",
  //           "id": 1,
  //           "cloud_model": "aws bedrock",
  //           "is_active": true,
  //           "configuration": {
  //             "temperature": 100,
  //           }
  // };
  sortOptions:any = [{ name: 'Most Used', value: 'most used' }, { name: 'Most Recent', value: 'most recent' }, { name: 'Old to New', value: 'old to new' }, { name: 'New to Old', value: 'new to old' }];

  isParValName:any = false;
  saveEditing: boolean = false;
  // isEditConf:boolean = false;
  configurationArray: any = [];
  // dataSource = ELEMENT_DATA;
  modelFormgroup: any = FormGroup;
  parameterName: string = '';
  parameterValue: string = '';
  parConfData: any = [{}];
  cloudModels: any = [
    { model: 'Aws Bedrock' },
    { model: 'Azure' }
  ]
  formSubmitted: boolean = false;
  // @ViewChildren(MatTable) _matTables: any;

  constructor(
      private dialogRef: MatDialogRef<AddModelDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public dialogData: any,
      private fb: FormBuilder
    ) {
      this.buildForm(dialogData);
    }

    ngOnInit() {
      if (this.dialogData && this.dialogData.configuration) {
      let filterConf = Object.entries(this.dialogData?.configuration).map(([key, value]) => {
        return { key, value, isEditing: false };
      });
      this.configurationArray = JSON.parse(JSON.stringify(filterConf));
    }
    }
    
    buildForm(data:any)  {
      this.modelFormgroup = this.fb.group({
        name: [data?.name || '', [Validators.required]],
        cloud_model: [data?.cloud_model, [Validators.required]],
        value: [data?.value,[Validators.required]]
      })
    }

    onInputParName(event:any) {
      if ( this.parameterName && this.parameterName?.charAt(0) === ' ') {
        this.parameterName = this.parameterName.trimStart();
      }
    }

    onInputParValue(event:any) {
      if ( this.parameterValue && this.parameterValue?.charAt(0) === ' ') {
        this.parameterValue = this.parameterValue?.trimStart();
      }
    }

    onInputEleKey(element:any) {
   
      
      if ( element && element.key?.charAt(0) === ' ') {
        element.key = element.key?.trimStart();
      }
    }

    onInputEleValue(element:any) {
      if ( element && element.value?.charAt(0) === ' ') {
        element.value = element.value?.trimStart();
      }
    }

    addParameter() {
      if (this.parameterName && this.parameterValue) {
        this.isParValName = false;
        this.configurationArray = [{key: this.parameterName,value: this.parameterValue,isEditing: false}, ...this.configurationArray];
        // this._matTables['_results'][0].renderRows();
        
        this.parameterName = '';
        this.parameterValue = '';
      } else {
        this.isParValName = true;
      }
    }

    submitModel() {
      this.formSubmitted = true;
      this.modelFormgroup.markAllAsTouched();
      if (this.modelFormgroup.invalid) {
        // handle form submission or error
  
        return;
      }
      const filterData = this.configurationArray.filter((item:any) => {
        if((item.key === null || item.key === undefined || item.key === '') || item.value === null || item.value === undefined || item.value === '') {
          return item;
        }
      })
      if (filterData.length) {
        return;
      }
      // if (this.isParValName && (this.parameterName == '' || this.parameterValue == '')) {
      //   return
      // }
      let formdata = this.modelFormgroup?.getRawValue();
      
      let confObj = this.convertToConfigurationObject();
      formdata.configuration = confObj;
      this.dialogRef.close(formdata);
    }

    convertToConfigurationObject(): any {
      let configuration: any;
      if (this.configurationArray && this.configurationArray.length) {
        configuration = this.configurationArray.reduce((acc:any, curr:any) => {
            // acc[curr.key] = curr.value;
            acc[curr.key] = (curr.value && !isNaN(curr.value)) ? Number(curr.value) : curr.value ;
            return acc;
        }, {});
    
        return configuration;
      }
      return configuration = {};
    }

    updateModel() {
      this.formSubmitted = true;
      this.modelFormgroup.markAllAsTouched();
      if (this.modelFormgroup.invalid) {
  
        return;
      }
      const filterData = this.configurationArray.filter((item:any) => {
        if((item.key === null || item.key === undefined || item.key === '') || (item.value === null || item.value === undefined || item.value === '') || item.isEditing) {
          this.saveEditing = true;
          return item;
        }
      })

      if (filterData.length) {
        return;
      }
      // if (this.isParValName && (this.parameterName == '' || this.parameterValue == '')) {
      //   return
      // }
      let formdata = this.modelFormgroup?.getRawValue();
      let confObj = this.convertToConfigurationObject();

      formdata.configuration = confObj;

      let changedData:any = {};

      Object.keys(this.dialogData).forEach(key => {
        if (this.dialogData[key] !== formdata[key]) {
          changedData[key] = formdata[key];
        }
      });

      // if (JSON.stringify(this.dialogData.configuration) !== JSON.stringify(formdata.configuration)) {
      //   changedData['configuration'] = formdata.configuration;
      // }

      if(JSON.stringify(this.dialogData.configuration) == JSON.stringify(formdata.configuration)){
        delete changedData.configuration;
      } else {
        changedData['configuration'] = formdata.configuration;
      }

      changedData = Object.fromEntries(Object.entries(changedData).filter(([_, value]) => value !== undefined));

      if (Object.keys(changedData).length > 0) {
        this.dialogRef.close(changedData);
      } else {
        this.dialogRef.close();
      }
    }

    cancelModel() {
      this.formSubmitted = false;
      this.dialogRef.close();
    }

    editRow(rowData:any) {

      rowData.isEditing = true;
      rowData.originalValue = { key: rowData.key, value: rowData.value };
    }

    deleteRow(rowData:any) {

      const index = this.configurationArray.findIndex((item:any) => item.key === rowData.key);
      if (index !== -1) {
        this.configurationArray.splice(index, 1);
        // this._matTables['_results'][0].renderRows();
     
      }
    }

    saveRow(element: any) {
   
      this.saveEditing = false;
      if ((element.key === '' || element.key === null || element.key === undefined)) {
        return;
      }

      if ((element.value === '' || element.value === null || element.value === undefined)) {
        return;
      }
      element.isEditing = false;
      const hasKeyChanged = element.originalValue.key !== element.key;
      const hasValueChanged = element.originalValue.value !== element.value;
      if (hasKeyChanged || hasValueChanged) {
     
    
        const index = this.configurationArray.findIndex((item:any) => item.key === element.originalValue.key);
        if (index !== -1) {
          this.configurationArray[index] = { ...element };
        }
        
        
      } else {
        console.log("No changes detected.");
      }

      element.isEditing = false;
  
    }
    
    closeRow(element:any) {
      this.saveEditing = false;
      
      element.key = element.originalValue.key;
      element.value = element.originalValue.value;
      element.isEditing = false;
    //   let catObj = this.categories.find((item:any) => (cat.id === item.id));
    // let subCatObj = catObj.sub_categories.find((item:any) => (subCat.id === item.id));
    // subCat.isEditing = false;
    // subCat.name = subCatObj.name;
    }

    viewModelInfo() {
      if (this.modelFormgroup.get('cloud_model')?.value == 'Azure') {
        window.open('https://platform.openai.com/docs/api-reference/responses/object', '_blank');
      } else if (this.modelFormgroup.get('cloud_model')?.value == 'Aws Bedrock') {
        window.open('https://docs.aws.amazon.com/bedrock/latest/userguide/model-parameters-anthropic-claude-messages.html#model-parameters-anthropic-claude-messages-request-response', '_blank');
      }
    }

}
